// src/i18n/cards.ts —— cards 域文案（06 user-h5 全局约定「卡状态 / 交易状态」、U-02、U-02a、U-03、U-04、U-04a、U-05、U-06a～c、U-20 条幅）
// 费率与欠费键（closeFee / txFee / crossBorderFee / declinedFee / disputeFee / feeOwedAdded）与 featurePending 由 i18n/shell.ts 定义，本域只引用
export const I18N_CARDS = {
  zh: {
    // 全局约定「卡状态」新增 4 态
    stRecharging: '充值中', stClosing: '销卡中', stClosed: '已注销', stFailed: '开卡失败',
    // 全局约定「交易状态」新增
    stAuthDelete: '已撤销', stRefundCancel: '退款已撤销', stDispute: '争议中', stMailCode: '验证码', stUnknown: '处理中',
    // U-02 / U-02a
    allCards: '全部卡片 ›', myCards: '我的卡', toastOpened: '开卡成功', toastOpenFailed: '开卡失败，费用已退回 USDT 余额',
    // U-03 费用行 4
    authCancelFee: '授权撤销费',
    authCancelFixed: '每笔 {fee} USDT',
    authCancelCond: '（撤销金额 ≥ {min} USD 时收取）',
    // U-04
    billingAddrHint: '账单地址须为{country}地址', minAmountHint: '最低首充 ${min_amount}{int}', minAmountIntSuffix: '，须为整数',
    errHolder: '持卡人姓名须为 1–50 位英文字母', errAddr: '请完整填写账单地址',
    // U-04 1214 OpenFeeChanged（0045 代理加价：开卡费按所属代理生效价，提交时价格已变）
    errOpenFeeChanged: '开卡费已调整为 {fee} USDT，请确认后重新提交',
    // U-04 美国账单地址（2026-10-15 用户反馈：州下拉 + 城市建议 + 邮编号段）
    addrStreet: '街道地址', addrCity: '城市', addrState: '州', addrZip: '邮编（5 位）',
    phState: '选择州', phCityPick: '选择城市', cityNeedState: '请先选择州', cityOther: '其他（手动输入）', phCityManual: '输入城市名（英文）',
    zipHintState: '{state} 邮编以 {ranges} 开头', zipHintNoState: '先选州，再填 5 位邮编',
    errUsState: '请选择账单地址所在的州', errUsCity: '请选择或填写城市', errUsCityFmt: "城市名只能包含英文字母、空格和 . ' -",
    errUsZip: '邮编须为 5 位数字', errUsZipState: '该邮编不属于所选州（{state}：{ranges}）',
    // U-04a
    kycNeedTitle: '需要完成身份认证',
    kycNeedSub: '未认证账户累计充卡上限为 ${kyc_limit}，完成认证后可提升至 ${kyc_limit_verified}。',
    goKyc: '去认证',
    // U-05
    limitTotal: '总额度', limitSpent: '已消费', limitAvailable: '可用额度', spentPending: '待核对', wdMaxText: '最多可转出 ${max}（卡上需保留 $0.01，全部取回请使用销卡）', wdAll: '全部', errWdMax: '最多可转出 ${max}，全部取回请使用销卡', spentPendingHint: '已消费与可用额度按最近交易估算，正在与发卡机构核对，核对完成后自动更新。', totalSyncText: '待核对', spentCoolingHint: '卡片刚有交易，需等待交易落定后才能转出，请约 {minutes} 分钟后重试。', addLimit: '增加额度', transferOut: '卡转出',
    toastSubmitted: '已提交，处理中', toastActionFailed: '操作未成功，请稍后再试',
    // U-06a / U-06b（errCardWdFee / cardWdFee：06 U-06b 授权前端决定）
    errCardAmtMin: '金额不能低于 $1', errCardWdFee: '转出金额须大于手续费 {fee} USDT', cardWdFee: '转出手续费',
    // U-06a 用户拍板 2026-10-15：增加额度行写 $，钱包扣款行写 USDT
    walletDeduct: '钱包扣款',
    // 体验评审 2026-10-15 #42：中文界面不出英文标签
    no3ds: '不支持 3DS',
    // U-20 S-60
    termsBanner: '继续使用即视为同意《用户协议》与《隐私政策》',
    // 交易详情：外币消费的原币金额（2026-10-19）
    origAmount: '原币金额',
    // REWRITES（原型键改写，出处见 REWRITES_CARDS）
    rechargeTitle: '增加卡额度', withdrawTitle: '卡转出', recharge: '增加额度', withdraw: '卡转出',
    toastRecharge: '已提交，额度增加中', toastWithdraw: '已提交，转出处理中',
    closeSub: '确定要销卡吗？提交后卡片将先冻结再注销，剩余可用额度扣除销卡费 {close_fee} USDT 后退回 USDT 余额（不足销卡费时全部留作销卡费），操作不可撤销。',
    // 体验评审 2026-10-15 #29 / #42：不写死地区与时效承诺，「卡段 / BIN」改「卡种」
    openCardSub: '多地区 Visa / Mastercard 可选', chooseBin: '请选择卡种', currentBin: '当前选择卡种：', moreFees: '查看全部费率 ▾', lessFees: '收起费率 ▴',
    toastOpen: '开卡申请已提交，通常几分钟内开通',
  },
  en: {
    stRecharging: 'Topping up', stClosing: 'Closing', stClosed: 'Closed', stFailed: 'Failed',
    stAuthDelete: 'Reversed', stRefundCancel: 'Refund reversed', stDispute: 'Disputed', stMailCode: 'Code', stUnknown: 'Processing',
    allCards: 'All cards ›', myCards: 'My cards', toastOpened: 'Your card is ready', toastOpenFailed: 'Card issuance failed — fees returned to your USDT balance',
    authCancelFee: 'Authorization reversal fee',
    authCancelFixed: '{fee} USDT per txn',
    authCancelCond: ' (when the reversed amount ≥ {min} USD)',
    billingAddrHint: 'Billing address must be in {country}', minAmountHint: 'Minimum ${min_amount}{int}', minAmountIntSuffix: ', whole numbers only',
    errHolder: 'Cardholder name must be 1–50 Latin letters', errAddr: 'Please complete the billing address',
    errOpenFeeChanged: 'The card opening fee is now {fee} USDT. Please review and submit again',
    addrStreet: 'Street address', addrCity: 'City', addrState: 'State', addrZip: 'ZIP code (5 digits)',
    phState: 'Select a state', phCityPick: 'Select a city', cityNeedState: 'Select a state first', cityOther: 'Other (type it in)', phCityManual: 'Enter the city name',
    zipHintState: '{state} ZIP codes start with {ranges}', zipHintNoState: 'Select a state, then enter the 5-digit ZIP',
    errUsState: 'Please select the billing state', errUsCity: 'Please select or enter a city', errUsCityFmt: "City may only contain letters, spaces and . ' -",
    errUsZip: 'ZIP code must be 5 digits', errUsZipState: 'This ZIP code is not in the selected state ({state}: {ranges})',
    kycNeedTitle: 'Verification required',
    kycNeedSub: 'Unverified accounts can top up cards up to ${kyc_limit} in total. Verify to raise it to ${kyc_limit_verified}.',
    goKyc: 'Verify now',
    limitTotal: 'Total limit', limitSpent: 'Spent', limitAvailable: 'Available', spentPending: 'Pending check', wdMaxText: 'Up to ${max} (keep $0.01 on the card; close the card to take out everything)', wdAll: 'All', errWdMax: 'You can transfer out up to ${max}; close the card to take out everything', spentPendingHint: 'Spent and available are estimated from your recent transactions while we confirm them with the issuer; they update automatically once confirmed.', totalSyncText: 'Pending check', spentCoolingHint: 'This card had a recent transaction. Transfers out are available once it settles — please try again in about {minutes} min.', addLimit: 'Add limit', transferOut: 'Transfer out',
    toastSubmitted: 'Submitted — processing', toastActionFailed: "The operation didn't go through. Please try again later",
    errCardAmtMin: 'Amount must be at least $1', errCardWdFee: 'Amount must exceed the {fee} USDT fee', cardWdFee: 'Transfer-out fee',
    walletDeduct: 'Charged to wallet',
    no3ds: 'No 3DS',
    termsBanner: 'By continuing you agree to the Terms and the Privacy Policy',
    origAmount: 'Original amount',
    rechargeTitle: 'Add card limit', withdrawTitle: 'Transfer out', recharge: 'Add limit', withdraw: 'Transfer out',
    toastRecharge: 'Submitted — adding to your limit', toastWithdraw: 'Submitted — transferring out',
    closeSub: 'Close this card? It will be frozen and then closed; your remaining available limit minus the {close_fee} USDT close fee returns to your USDT balance (if it is less than the fee, it is all kept as the fee). This cannot be undone.',
    openCardSub: 'Visa / Mastercard across multiple regions', chooseBin: 'Choose a card type', currentBin: 'Selected card type: ', moreFees: 'View all fees ▾', lessFees: 'Hide fees ▴',
    toastOpen: 'Card requested — usually ready within minutes',
  },
} as const;

// TD-805：覆盖原型字典的键。rechargeTitle / withdrawTitle / toastRecharge / toastWithdraw：06 U-06a / U-06b 改写（D30 / D33）；
// recharge / withdraw：06 U-05 宫格文案改写为 addLimit / transferOut（D30）；closeSub：06 U-06c 改写全文（D12 / D34）；
// openCardSub / chooseBin / currentBin / toastOpen：体验评审 2026-10-15 #29 / #42（不写死地区与开卡时效，「卡段」改「卡种」）
export const REWRITES_CARDS: readonly string[] = [
  'rechargeTitle', 'withdrawTitle', 'recharge', 'withdraw', 'toastRecharge', 'toastWithdraw', 'closeSub', 'openCardSub', 'chooseBin', 'currentBin', 'toastOpen',
];
